import {useState, useEffect} from "preact/compat";

export const useThirdStep = (props) => {
    // Destructured props
    const {
        handleStepChange,
        handlePayloadUpdate
    } = props;

    // Form values data object
    const [formValues, setFormValues] = useState({
        answer:            null,
        additionalComment: ""
    });
    // Flags that the remaining options should be disabled when the positive option is selected
    const [shouldDisableOptions, setShouldDisableOptions] = useState(false);

    // Procedure to handle all value changes
    const handleChange = (e) => {
        // Destructured event props
        const {
            name,
            value
        } = e.target;

        // Updates the formValues state with the new value
        setFormValues(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        })

        // Happy ending
        if (name === "answer" && value === "1") {
            // Disable all options
            setShouldDisableOptions(true);
        }
    }

    // Procedure to handle the form submission
    const handleSubmit = (
        e = undefined
    ) => {
        if (e) {
            // Prevents page from reloading
            e.preventDefault();
        }

        // Synchronizes the payload state with the current step's form values
        handlePayloadUpdate({
            data: {
                question_text: "Você encontrou tudo que precisava?",
                question_type: "advanced",
                option: formValues.answer === "0" ? "Não" : "Sim",
                input: formValues.additionalComment,
            }
        });

        // Proceeds to the next step
        handleStepChange({
            action: "NEXT"
        });
    }

    // Effect to lock all the options and submit the form after a one-second delay
    useEffect(() => {
        if (!shouldDisableOptions) {
            return;
        }

        // Submits the form after a one-second delay
        const timer = setTimeout(() => {
            handleSubmit();

            clearTimeout(timer);
        }, 1000);
    }, [shouldDisableOptions]);

    return {
        formValues,
        shouldDisableOptions,
        handleChange,
        handleSubmit
    }
}
